import {
  HttpClient,
  HttpHeaders,
} from '@angular/common/http';
import {
  EventEmitter,
  Injectable,
  Output,
} from '@angular/core';
import { Router } from '@angular/router';

import * as $ from 'jquery';
import {
  Observable,
  Subject,
} from 'rxjs';
// import { Checkout } from 'capacitor-razorpay';
import {
  AlertController,
  Platform,
  PopoverController,
  LoadingController,
  ModalController,
  NavController,MenuController
} from '@ionic/angular';

import { ProfileMenuComponent } from '../components/profile-menu/profile-menu.component';
import { CartService } from './cart.service';
// import { SubscribePlanPage } from '../pages/subscribe-plan/subscribe-plan.page';
// import { AngularFireDatabase, AngularFireObject } from '@angular/fire/compat/database';
import { environment } from 'src/environments/environment';
import { Geolocation } from '@awesome-cordova-plugins/geolocation/ngx';
import { Storage } from '@ionic/storage-angular';
import OneSignal from 'onesignal-cordova-plugin';

declare var Razorpay :any;

@Injectable({
  providedIn: 'root'
})
export class DataService {
  added_animate = new Subject();

  headers;
  options:any;
  registerform;
  device_type: any = 'desktop';
  public isApp = false;
  scroll_data = true;
  isTrue_product:any=[];
  isTrue_category:any=[];
  categories: any=[];
  // product:any=[];
  shipping_method:any=[];
  payment_method:any=[];
  domain = environment.app_config.domain;
  domaintype = environment.app_config.domain_type
  domainUrl = `${this.domaintype}://${this.domain}/`;
  domainResourceUrl = `${this.domaintype}://${this.domain}/api/resource/`;
  domainMethodUrl = `${this.domaintype}://${this.domain}/api/method/`;
  apiUrl_common = 'ecommerce_business_store.ecommerce_business_store.v2.common.'
  apiUrl_carts = 'ecommerce_business_store.ecommerce_business_store.v2.cart.'
  apiUrl_customer = 'ecommerce_business_store.ecommerce_business_store.v2.customer.'
  apiUrl_product = 'ecommerce_business_store.ecommerce_business_store.v2.product.'
  apiUrl_category = 'ecommerce_business_store.ecommerce_business_store.v2.category.'
  apiUrl_checkout = 'ecommerce_business_store.ecommerce_business_store.v2.checkout.'
  apiUrl_orders = 'ecommerce_business_store.ecommerce_business_store.v2.orders.'
  apiUrl_vendor = 'ecommerce_business_store.ecommerce_business_store.v2.vendor.'
  apiUrl_masters = 'ecommerce_business_store.ecommerce_business_store.v2.masters.'
  // public baseMethod = 'https://gokommerce.com/api/method/';
  // public baseResource = 'https://gokommerce.com/api/resource/';
  // public baseUrl = 'https://gokommerce.com';
  public is_menu_enabled = false;

  data_store:any = [];
  driver_proofs:any = [] ;

  ismobile: any;
  istab: any;
  childs: any = {};
  category:any = [];
  choosed_brands:any = [];
  choosed_attributes:any = [];
  choosed_product_id:any;//choosed produt list
  view = 'list';
  column_value = '12';
  minimax_price: any = {};
  rating:any;
  order_item: any
  allOrders: any;
  all_orders: any;
  cus_list: any;

  cart_items:any = [];
  cart_count:any = 0; //My cart count
  wish_count:any = 0;
  cart_data: any = {};
  sub = new Subject();
  order_tab = new Subject();
  change_pos_date = new Subject();
  change_address = new Subject();
  change_customer = new Subject();
  select_customer = new Subject();
  product_detail = new Subject();
  select_role_customer = new Subject();
  select_all_category = new Subject();
  start_cart = new Subject();
  price_submit = new Subject();
  tab_center = new Subject();

  sub_total = 0;
  items: any;//cus-orders-component
  public Customer: any;
  public customer_adr_id: any;
  public is_pos_offline: any = false;
  public currency = localStorage['currency'];
  public common_settings: any;
  public search_product: any;
  public isNgCart = true;
  public shipping_name:any;
  public wallet_settings:any;
  /* web form */ 
  doc_type:any;
  ref_doc_type:any;
  ad_name:any;
  web_from_name:any;
  httpHeaders: any;
  httpOptions: any;
  modeofpayment:any = [];
  search_productss:any = [];
  selected_items:any = [];
  stack_tranfer = false;
  inventory:any=[];
  search_empty=[];
  /* Orders var */ 
  filters = {
    all: true,
    new: false,
    complete: false,
    Cancelled:false
  };
  p_pageNo = 0;
  searchText:any
  page_no = 1;
  showSection=true;
  typeOfData: any;
  pendingorders: any = [];
  p_loadMoreData = false;
  show = false;
  active: any;
  item:any;
  cols = 3;
  rows = 9;
  left_Width = 25;
  right_Width = 75;
  orders_list = true;
  scroll_top = true;
  report = new Subject();
  modal_popup = false;
  Menu_report = true;
  side_menu = false;
  searchCustomer: any;
  address_list:any=[];
  Wallet_points = true;
  id_sub_category = false;
  order_popup = true;
  order_Detail = false;
  inventory_page_no = 1;
  search_txt : any='';
  path:any;
  webscan = false;
  history_item:any
  @Output() order_data: EventEmitter<any[]> = new EventEmitter();
  is_order:any= false;
  code:any;
  ordertype_name:any;
  shipping_charges :any = {};
  total_amount = new Subject();
  subscribe_emit = new Subject();
  print_emit = new Subject();
  subscription_plan_info_status:any;
  modal = false;
  razorpay_settings :any ={};
  razorpay_payment = new Subject();
  pay_amount:any;
  pay_amount_= new Subject();
  restaurant_name:any;
  Allow_return = false;
  make_return:any;
  // itemRef: AngularFireObject<any>;
  
  no_of_copy:any;
  sales_type:any;

  redeem_wallet = false;
  is_shipping_msg:any;
  is_shipping = false;
  paymentMethod:any;
  active_sales_type:any;
  delivery_slots:any =[];
  selected_slot:any = [];
  selected_slot_label : any = {};

  location_info:any = { zipcode : '',country :'',state :'',city:'',address:'',latitude:'' ,longitude:''}
  located = new Subject();
  location_error  = false;
  location:any;
  city:any;
  available_location = false;
  product_info: any = {
    product : {
      product_attributes:[],
      product_images : [],
      product_categories : [],
    },
  };
  alert_animate = new Subject();

  product_set:any={};
  tabs= false;
  rich_text:any;
  get_product_brands:any=[];
  specifications_group:any=[];
  specifications_attributes:any=[];
  specification_data:any={};
  discount_templates:any=[];
  image_page:any;
  scroll_top_1 = new Subject();
  map_fields_get = new Subject();
  login_info:any = {};

  inventory_items:any = [];
  centres_list:any = [];
  fullscreen1 = true;
  split_screen: boolean=true;
  normal_login = true;
  checkout_cod = false;
  is_show:boolean = true;
  added_price_list:any=[];
  add_price = new Subject();
  offer_details:any  = [];
  botton_name;
  edit_product_value:any;
  variant_shown = false;
  is_select = false;
  otp_form = false;
  update_product = new Subject();
  hide_price_categories = false;
  hide_cat_categories = false;
  scroll_event: any = { desktop_header: true, mobile_header: false, no_search_icon: false }; //Scrolling data
  cust_name:any;
  cust_email:any;
  alert_bg = '#ef5959f2';
  app_version:any;
  // public geo:Geolocation,public fire: AngularFireDatabase,
  constructor(private menu: MenuController,public geo:Geolocation,public router:Router,private alertCtrl: AlertController, public popoverCtrl: PopoverController, private platform: Platform, public http: HttpClient,public ngcart: CartService,private modalCtrl:ModalController,public storage: Storage) {
    this.headers = new HttpHeaders({ 'withCredentials': 'true' });
    if ((this.platform.is('android') || this.platform.is('ios')) && this.platform.is('mobileweb'))
      this.device_type = 'mobile';
   
   this.product_set.tax = false;
   this.product_set.description = true;
   this.product_set.tax = false;
   this.product_set.display_home_page = false;
   this.product_set.is_gift_card = false;
   this.product_set.description = false;
   this.product_set.description = false;
   this.product_set.description = false;
     
  }

  order_click(item:any) {
    this.items = item;
  }

  async show_menu(type = 'default') {
    const popover = await this.popoverCtrl.create({
      component: ProfileMenuComponent,
      cssClass: 'submenu',
      showBackdrop: false,
      componentProps: {
        menu_type: type
      }
    })
    await popover.present();
  }

  check_mobile() {
    let width = this.platform.width()
    if (width < 768) {
      this.ismobile = true
    } else {
      this.ismobile = false
    }
  }

  authendicate(){
    if(localStorage['domain_api_key'] && localStorage['domain_api_secret'] && localStorage['domain_customerId']){
    
    }else if(!localStorage['domain_api_key'] && !localStorage['domain_api_secret'] && !localStorage['domain_customerId']){
      localStorage.clear();
      this.router.navigate(["/admin-dashboard"]);
      let width = this.platform.width()
      if (width > 768 && width < 992) {
        this.tabs = true
      } else {
        this.tabs = false
      }    
    }
  }
  
  check_tab() {
    let width = this.platform.width()
    if (width > 768 && width < 992) {
      this.istab = true
    } else {
      this.istab = false
    }
  }

  // // Realtime data change by firebase

  // watching(): Observable<any> {
    // this.playAudio()
    // this.itemRef = this.fire.object('Order');
    // return this.itemRef.valueChanges();
  // }


  getPaddedComp(comp:any) {
    return ((parseInt(comp) < 10) ? ('0' + comp) : comp)
  }

  today_date() {
    var t1 = new Date();
    var m1 = t1.getMonth() + 1;
    var today_date = t1.getFullYear() + "-" + this.getPaddedComp(m1) + "-" + this.getPaddedComp(t1.getDate());
    return today_date
  }


  get windowRef() {
    return window;
  }

  checkmobile() {
    let width = this.platform.width();
    if (width > 768) {
      return false
    } else {
      // if (width < 768)
      return true;
    }
  }

  async alert(data:any) {
    // console.log(data)
    const alert = await this.alertCtrl.create({
      header: 'Alert',
      subHeader: data,
      buttons: ['Ok']
    })
    await alert.present();
  }

  async auto_close_alert(data:any) {
    // console.log(data)
    const alert = await this.alertCtrl.create({
      header: 'Alert',
      subHeader: data,
      buttons: ['Ok']
    })
    await alert.present();

    setTimeout(() => {
      alert.dismiss();
    }, 2000);
  }

   zipcode_availbility(zip_code:any,address:any){
     
      zip_code == 'local' ? zip_code = address.zipcode : '';
      // if(this.website_settings.enable_zipcode == 1){
      //   if(this.website_settings.radius_based_validation == 1){
          this.radius_base(zip_code,address);
      //   } else {
      //     this.ismobile ? this.zipcode_availbility_phone(address.zipcode,'empty') : this.zipcode_base(zip_code,address); 
      //   }
      // }else{
      //   this.available_location = false;
      // }
    }

    radius_base(zip_code:any,address:any){

   let d = {"business" : localStorage['business'] , lat: this.location_info.latitude,lng:this.location_info.longitude}
    this.check_distance_by_latlng(d).subscribe(res =>{
      // console.log(res);
      if(res.message.status == 'success'){
        this.location_error = false;
        this.available_location = false;
        // if(address != 'empty'){
        //   address.zipcode ? this.store_local_location(address,zip_code) :  this.store_map_location(address,zip_code)
        //   this.ismobile ? this.router.navigateByUrl('/tabs/home') : (this.modal_stacks.includes('location-modal') ?  this.modalCtrl.dismiss() : null);
        // } 
        // this.modal_stacks.includes('location-modal') ?  this.modalCtrl.dismiss() : null
      } else {
        this.location_error = res.message.message;
        this.available_location = true;
        //  this.db.location = undefined;
      }
      setTimeout(() => {   window.dispatchEvent(new Event('resize')); }, 100);
  })
}




    async current_locate(type) {
    this.location_error = false;
    localStorage.removeItem("city");
    this.geo.getCurrentPosition().then((resp) => {
      this.location_info.permission_error = false
        this.location_info.latitude = resp.coords.latitude //13.0381896 //
        this.location_info.longitude = resp.coords.longitude// 80.1565461 //
        this.located.next('located');
        // console.log(resp)
        let locations = new google.maps.LatLng(resp.coords.latitude, resp.coords.longitude);
        this.decode(locations,type);
        // console.log(locations)
     }).catch((error:any) => {
      error.message == 'User denied Geolocation' ? this.location_info.permission_error = true : this.location_info.permission_error = false
      // this.ismobile && this.website_settings.enable_multi_store == 1 ? this.router.navigateByUrl('/unavilable-location') : null;
    });
  }


  
  get_razorpay_setting() {
    // this.get_razorpay_settings().subscribe((r: any) => {
    //   // console.log(r)
    //   	if(r.message != undefined){
    //       // console.log("Razor pay",r.message)
    //         this.razorpay_settings = r.message;
    // 	}
    //   }, (error:any) => {   
    //     //  console.log(JSON.stringify(error.json())); 
    //     });
  }

  // get_order_type():Observable<any>{
  //   let endpoint = environment.firebaseConfig.databaseURL+"/Ordertype.json";
  //   return this.http.get(endpoint);
  // }

  // get_sales_type():Observable<any>{
  //   let endpoint = environment.firebaseConfig.databaseURL+"/Salestype.json";
  //   return this.http.get(endpoint);
  // }

  getSlot(delivery_method:any){
  let slots:any = [];
   var data = {  shipping_method : delivery_method , customer_id : this.Customer?this.Customer.name:'', }
   this.get_cart_delivery_slots(data).subscribe(res => {
         if(res.message){
             res.message.map( (value:any) =>{
              slots.push(value);
           })
         }
   })
   this.delivery_slots = slots;
 }



    
    check_which(data:any){
      let d = data.split(',')
      return d
     } 


     async order_payment_capture(id:any,order_id:any) {
        // let loader = await this.loadingCtrl.create({ message: 'Please Wait...'});
        // await loader.present();
        if(id){
          var updatedate = {  'order_id': order_id,  'transaction_id': id  }
          this.update_order_status(updatedate).subscribe(r => {
              this.success(order_id);
          }, error => { 
            
           });
        }  else {
          
          this.success(order_id);
        }
  
          // this.success();
        // }
      // }
  }
     
  attach_filter(data,color){
    var str = data.split('.');
     let value = str[1];
     value = value.toLowerCase();
      if(value && (value == 'apng' || value == 'avif' || value == 'gif' || value == 'jpeg' || value == 'jfif' || value == 'pjpeg' || value == 'pjp' || value == 'webp' || value == 'png' || value == 'svg' || value == 'jpg')){
        return `/assets/icon/msg/photo${color}.svg`
      }else if(value && value == 'pdf'){
        return `/assets/icon/msg/pdf${color}.svg`
      }else if(value && value == 'ppt'){
        return `/assets/icon/msg/ppt${color}.svg`
      }else if(value && (value == 'webm' || value == 'mpg' || value == 'mp2' || value == 'mpe' || value == 'ogg' || value == 'mp4'|| value == 'm4v' || value == 'avi' || value == 'wmv' || value == 'mov' || value == 'qt' || value == 'flv' || value == 'swf' || value == 'avchd' )){
        return `/assets/icon/msg/video${color}.svg`
      }else if(value && value == 'zip'){
        return `/assets/icon/msg/zip${color}.svg`
      }else{
        return `/assets/icon/msg/pdf${color}.svg`
      }
  }

  success(order_id:any){
      this.cart_data = {}
      this.cart_items = [];
      this.cart_count = 0;
      this.wish_count = 0;
  }

  product_img(data:any) {
    if (data) {
      if (data.indexOf('https') == -1 && data.indexOf('data:image') == -1) {
        return this.domainUrl + data;
      } else if (data.indexOf('https') == 0 || data.indexOf('data:image') == 0) {
        return data
      }
      else{
        return 'assets/no-img.jpg'
      }
        // return 'assets/no_products.png'
    }
    else{
      return 'assets/no-img.jpg'
    }
      // return 'assets/no-product.png'
  }

  plusCount(count:any) {
    count = count + 1;
    return count;
  }


  removeCount(count:any) {
    if (count != 0) {
      count = count - 1;
      return count;
    } else {
      return 0;
    }
  }


  open_image(url:any) {
    if (url != undefined || url != null) {
      if (url.indexOf('http') != -1)
        return url;
      else
        return this.domainUrl + url;
    }
    else
      return 'assets/default-img.jpg';
  }

  check_image(url:any) {
    // if (url != undefined || url != null) {
    if (url.indexOf('http') != -1){
      return url;
    } else {
      return this.domainUrl + url;
    }

    // else
      // return 'assets/default-img.jpg';
  }



  get_domain(endpoint: string) {
    if (localStorage['domain_api_key'] != undefined)
      this.headers = new HttpHeaders({ 'Authorization': 'token ' + localStorage['domain_api_key'] + ":" + localStorage['domain_api_secret'] });
    this.options = ({ headers: this.headers });
    return this.http.get(endpoint, this.options);
  }

  

  post_method(endpoint: string, data:any) {
    if (localStorage['domain_api_key'] != undefined)
      this.headers = new HttpHeaders({ 'Authorization': 'token ' + localStorage['domain_api_key'] + ":" + localStorage['domain_api_secret'] });
    if ((localStorage['domain_customerId']) && (this.device_type == 'mobile' || localStorage['domain_api_key']))
      this.options = ({ headers: this.headers });
    else
      this.options = {};
    return this.http.post(endpoint, data, this.options);
  }

  /* web forms api */ 

    // Alert Message
    async presentAlert() {
      const alert = await this.alertCtrl.create({
        cssClass: 'my-custom-alert-class',
        header: "Alert.!",
        message: 'Submitted Successfully...!',
        buttons: [{
          text: 'OK',
          handler: () => {
            this.alertCtrl.dismiss();
          }
        }]
      });
      await alert.present();
    }

  // Orders page function

  pending_orders(type:any,sales_type:any) {
    // console.log("Order_cancel",sales_type);
    var data = {
      // restaurantId: localStorage['business'],
      // limit_start: this.page_no,
      // limit_page_length: 15,
      // // status:"Completed,Cancelled",
      // status: sales_type == 'order'? type :'',
      // sales_type: sales_type == 'sales'?type:''
      // restaurantId: localStorage['business'],
      page_no: this.page_no,
      page_size: 15,
      status: sales_type == 'order'? type :'',
      // status: type ? type : '',
      start_date: '',
      end_date: '',
      search_text: this.searchText
    };
    this.stauts_based_admin_orderlist(data).subscribe(
      (data:any) => {
        if (data.message && data.message.length != 0) {
          this.getRandomColor(data.message);
          this.page_no == 1 ? this.pendingorders = data.message : this.pendingorders = [...this.pendingorders,...data.message]
          // data.message.map(value =>{
          //   this.page_no != 0 ? this.pendingorders.push(value) : []
          // })

          this.page_no == 1 ? this.order_tab.next('order tab changes') : ''
          // this.page_no = this.page_no + 10;
          // this.pendingorders = data.message;
          // this.orderdetail(this.pendingorders[0], 0);
          // $.merge(this.pendingorders,data.message)
          this.is_order = true;
          this.p_loadMoreData = true;
        } else {
          this.p_loadMoreData = false;
          this.is_order = true;
          this.page_no == 1 ? this.pendingorders=[] : null;
          // this.pendingorders = [];
        }
        // if (data.message.length < 10) {
        //   this.p_loadMoreData = false;
        // }
      },
      (error:any) => {}
    );
  }

  orderdetail(l:any, index:any) {
    this.showSection = true
    this.item = l;
    this.active = index;
    let width = this.platform.width();
    if (width > 768) {
      this.show = true;
    } else if (width < 768) {
      this.show = true;
      // return true;
    }
  }

  shipping_charge(address:any){
    let data={
      shipping_addr: address.name,
      subtotal:this.sub_total,
      shipping_method: this.shipping_name,
      ngCart: JSON.stringify(this.ngcart.TableCartItems('')),
      domain:this.domain
    }
    this.calculate_vendor_based_shipping_charges(data).subscribe((res:any)=>{
      // console.log(res['message'])
      if(res['message'].status == 'failed'){
        this.is_shipping = true;
        this.is_shipping_msg = res['message'].message;
        this.alert(res['message'].message)
      }else{
      this.is_shipping = false;
      this.shipping_charges = res['message'];
      // console.log(this.shipping_charges)
      // console.log(this.shipping_charges.shipping_charges)
      // this.shipping_charges.shipping_charges = 5
      this.total_amount.next('get');
    }
    })
  }

  getMethod(){
      var data={  domain:this.domain, subtotal: this.sub_total,shipping_method:this.shipping_name,
        customer_id:this.Customer.name, ismobile:1, is_pos:1 }
    this.get_payment_method(data).subscribe((r: any) => {
      if(r.message != undefined){
        let check = r.message.filter((obj:any) => obj.allowed == 1)
        // console.log(check)
        this.paymentMethod = check;
        if(check){
          localStorage['payment_method'] = this.paymentMethod[0].name;
          // this.payment_method = this.paymentMethod[0].name;
          this.paymentMethod ? this.paymentMethod[0].value  = Number(this.pay_amount):0;
          this.paymentMethod ? this.paymentMethod[0].show  = true:false;

        }
        // this.select_payment(this.paymentMethod[0].name);
      }
      }, error => {
        console.log(JSON.stringify(error.json()));
      });
  }

  search_function(){
      this.is_order = false;
      this.filters.all =true;
      this.filters.complete =false;
      this.filters.new =false;
      this.filters.Cancelled =false;
      this.active_sales_type = ''
    if (this.searchText!= undefined && this.searchText != '') {

      this.pendingorders= [];
      this.page_no = 1;
      this.pending_orders('','order');
      
    }
    else {
      this.page_no = 1;
      //  console.log("3");
      this.pending_orders('','order');
    }
     
      // this.get_customerslist('');
     // this. filterOrder('all'); 
    }

    filterOrder(arg:any) {
       this.active_sales_type = '';
       this.is_order = false;
      if (arg == 'all') {
        (this.filters.all = true),
          (this.filters.new = false),
          (this.filters.Cancelled = false),
          (this.filters.complete = false);
          this.searchText = '';
        this.page_no = 1;
        // this.pendingorders = undefined;
        this.pending_orders('','order');
        this.typeOfData = '';
      } else if (arg == 'new') {
        (this.filters.all = false),
          (this.filters.new = true),
          (this.filters.Cancelled = false),
          (this.filters.complete = false);
          this.searchText = '';
        this.page_no = 1;
        // this.pendingorders = undefined;
        this.pending_orders('Placed','order');
        this.typeOfData = 'Placed';
      } else if (arg == 'complete') {
        (this.filters.all = false),
          (this.filters.new = false),
          (this.filters.Cancelled = false),
          (this.filters.complete = true);
          this.searchText = '';
        this.page_no = 1;
        // this.pendingorders = undefined;
        this.pending_orders('Completed','order');
        this.typeOfData = 'Completed';
      }else if (arg == 'Cancelled') {
        (this.filters.all = false),
          (this.filters.new = false),
          (this.filters.complete = false),
          (this.filters.Cancelled = true);
          this.searchText = '';
        this.page_no = 1;
        // this.pendingorders = undefined;
        this.pending_orders('Cancelled','order');
        this.typeOfData = 'Cancelled';
      }
      else{
          (this.filters.all = false),
          (this.filters.new = false),
          (this.filters.complete = false),
          (this.filters.Cancelled = false);
          this.searchText = '';
          this.page_no = 1;
          this.pending_orders(arg,'sales');
          this.typeOfData = arg;
          this.active_sales_type = arg;
          // console.log(arg)
      }
    }

    // Return Request status
    Return_request_status(order_id:any){
      let data ={
        'order_id' : order_id
      }
      this.return_request_status(data).subscribe((res:any) =>{
        if(res.message.allow_return ! = 0){
          this.Allow_return = true;
        }
      })
    }

    get_retuen_products(order_id:any){
      let data ={
        order_id : order_id
      }
      this.get_return_request_info(data).subscribe(res=>{
        //  console.log(res)
        let return_products = res.message;
        return_products.order_item && return_products.order_item.length != 0 ? this.make_return = true : this.make_return = false
        // console.log('this.make_return',this.make_return)
        // return_products.order_item.map(r=>{
        //   this.make_return = true;
        // })
      })
    }


    // for subscription
async buy_now() {
  // this.open_subscriber();
}


get_oneSignal_id(): Observable<any> {
    let endpoint = environment.firebaseConfig.databaseURL + "/one_signal.json";
    return this.http.get(endpoint);
  }


OneSignalInit(key) {
    OneSignal.setAppId(key);
    OneSignal.setNotificationOpenedHandler((data) => {
      if (data.notification.body.indexOf('Your order') != -1 || data.notification.body.indexOf('your order') != -1) {
        // this.nav.push(OrderPage,{name:data.notification.additionalData['add_data'], type:'order'})
      }
      else {
        
      }
      // console.log('notificationOpenedCallback: ' + JSON.stringify(jsonData));
    });
    OneSignal.promptForPushNotificationsWithUserResponse((accepted) => {
      console.log('User accepted notifications: ' + accepted);
    });
    OneSignal.getDeviceState((res) => {
      // console.log(res)
      localStorage['player_id'] = res.userId;
      localStorage['domain_customerId'] && localStorage['player_id'] && localStorage['player_id'] != "undefined" && localStorage['player_id'] != undefined ? this.update_onsignal_id().subscribe(res => { console.log("one signal id updated..", res) }) : null
    })
    // }
  }

 // Orders page function end

  get_values(){
    if(this.scroll_data){     
      let data ={
        page_no : this.inventory_page_no,
        page_size : 10,
        search_txt : this.search_txt
      }
      this.get_inventory_values(data).subscribe((r:any)=>{ 
        if(this.inventory_page_no == 1){
          this.inventory = r['message'];
          this.search_productss = r['message'] 
          this.scroll_data = true;
        } else{         
          if(r['message'].length != 0){
            r['message'].map((res:any)=>{
              this.inventory.push(res);
            })
            this.scroll_data = true;
          }else{
            this.scroll_data = false;
          }
        }   
      })
    }
  }

  product_category(data:any) {
    let endpoint =  this.apiUrl_vendor + 'get_categories'
    return this.get_domain(this.domainMethodUrl + endpoint);
  }


  update_onsignal_id(): Observable<any> {
    var playerId = { device_id: localStorage['player_id']}
    let endpoint = 'ecommerce_business_store.ecommerce_business_store.v2.sales_executive.update_seller_device_id'
    // let endpoint = this.apiUrl_customer + 'update_device_id';
    return this.post_method(this.domainMethodUrl + endpoint,playerId);
  }

  get_app_version(): Observable<any> {
    let endpoint =  "https://districo-tridots-default-rtdb.firebaseio.com/vendor_app_version.json";
    return this.http.get(endpoint);
  }

  get_restaturantdetail(id:any) {
    var data = {
      name: id
    }
    let endpoint = 'ecommerce_business_store.ecommerce_business_store.mobileapi.get_business_detail';
    return this.post_method(this.domainMethodUrl + endpoint, data);
  }

  get_subscribed_plans(data:any) {
    let endpoint = 'subscription.subscription.api.get_customer_plan_based_subscritpions';
    return this.post_method(this.domainMethodUrl + endpoint, data);
  }

  make_refund(data:any) {
    let endpoint = 'ecommerce_business_store.ecommerce_business_store.doctype.order.order.make_refund';
    return this.post_method(this.domainMethodUrl + endpoint,data);
  }

  list_subscription_plans():Observable<any>{
    let endpoint = 'subscription.subscription.api.list_subscription_plans';
    return this.http.get(this.domainMethodUrl + endpoint);
  }

  get_cart_delivery_slots(data:any):Observable<any>{
    let endpoint = 'ecommerce_business_store.ecommerce_business_store.api.get_cart_delivery_slots';
    return this.post_method(this.domainMethodUrl + endpoint, data);
  }

  calculate_vendor_based_shipping_charges(data:any) {
    let endpoint = 'ecommerce_business_store.ecommerce_business_store.api.calculate_vendor_based_shipping_charges'
    return this.post_method(this.domainMethodUrl + endpoint, data);
  }
  
  get_inventory_values(data:any) {
    let endpoint = 'inventory_management.stock.api.get_products_bin_details';
    return this.post_method(this.domainMethodUrl + endpoint, data);
  }

  update_order_status(data:any):Observable<any> {
    let endpoint = 'ecommerce_business_store.ecommerce_business_store.mobileapi.update_order_status'
    return this.post_method(this.domainMethodUrl + endpoint, data);
  }

  update_order_detail_status(data:any){
    let endpoint =  this.apiUrl_vendor +'update_order_status';
    return this.post_method(this.domainMethodUrl + endpoint ,data);
  }

  send_otp(data): Observable<any> {
    let endpoint = this.apiUrl_vendor + "send_otp"
    return this.post_method(this.domainMethodUrl + endpoint, data);
  }

  verify_otp(data): Observable<any> {
    let endpoint = this.apiUrl_vendor + "verify_otp"
    return this.post_method(this.domainMethodUrl + endpoint, data);
  }

  get_return_policies(): Observable<any> {
    let endpoint = this.apiUrl_vendor + "get_return_policies"
    return this.get_domain(this.domainMethodUrl + endpoint);
  }

  get_replacement_policies(): Observable<any> {
    let endpoint = this.apiUrl_vendor + "get_replacement_policies"
    return this.get_domain(this.domainMethodUrl + endpoint);
  }

  get_brands(): Observable<any> {
    let endpoint = this.apiUrl_vendor + "get_brands"
    return this.get_domain(this.domainMethodUrl + endpoint);
  }


  get_stock_history(data:any) {
    let endpoint = 'inventory_management.stock.api.get_product_stock_history';
    return this.post_method(this.domainMethodUrl + endpoint, data);
  }

  // https://go1grocery.com/api/method
  // inventory_management.stock.api.insert_stock
  insert_stock(data:any): any {
    var datas = {
      data: JSON.stringify(data)
    }
    let endpoint = 'inventory_management.stock.api.insert_multiple_stock';
    return this.post_method( this.domainMethodUrl + endpoint, datas)
  }

  stauts_based_admin_orderlist(data:any): any {
    let endpoint =  this.apiUrl_vendor + 'get_order_list'
    // let endpoint = 'ecommerce_business_store.ecommerce_business_store.mobileapi.stauts_based_admin_orderlist'
    return this.post_method(this.domainMethodUrl + endpoint, data);
  }

  insert_customer(data:any, index:any) {
    let endpoint = 'ecommerce_business_store.ecommerce_business_store.mobileapi.insert_customers';
    return this.post_method(this.domainMethodUrl + endpoint, data);
  }

  domain_get_states_lists(country:any) {
    let endpoint = 'ecommerce_business_store.ecommerce_business_store.api.get_country_states?country=' + country;
    return this.get_domain(this.domainMethodUrl + endpoint);
  }

  domain_get_country_list() {
    let endpoint = 'ecommerce_business_store.ecommerce_business_store.mobileapi.get_country_list';
    return this.get_domain(this.domainMethodUrl + endpoint);
  }
  /* get wallet details*/
  get_wallet_details(data:any): Observable<any> {
    let endpoint = 'ecommerce_business_store.accounts.api.get_wallet_details'
    return this.post_method(this.domainMethodUrl + endpoint, data);
  }
  /*Reward Points*/

  checkout_redeem_points(data:any): any {
    let endpoint = 'loyalty.loyalty.api.checkout_redeem_points';
    return $.post(this.domainMethodUrl + endpoint, data, this.options);
  }

  get_customer_points(data:any): Observable<any> {
    let endpoint = 'loyalty.loyalty.api.get_customer_points'
    return this.post_method(this.domainMethodUrl + endpoint, data);
  }
  /*Get Points History*/
  get_point_history(data:any): Observable<any> {
    let endpoint = 'loyalty.loyalty.api.get_point_history'
    return this.post_method(this.domainMethodUrl + endpoint, data);
  }

  get_support(data:any){
    let endpoint = `${data.doctype}?fields=["*"]&limit_start=${data.start}&limit_page_length=${data.length}&filters=[["business","=",${JSON.stringify(localStorage['business'])}]]`;
    return this.get_domain(this.domainResourceUrl + endpoint);
  }

   admin_Info(email:any): any {
    var data = {
      user: email,
      role: "Vendor",
      doctype: "Shop User"
    }
    let endpoint = 'ecommerce_business_store.ecommerce_business_store.mobileapi.get_manager_info';
    return this.post_method(this.domainMethodUrl + endpoint, data);
  }

  makepayment(data:any) {
    let endpoint = 'ecommerce_business_store.accounts.api.make_payment';
    return this.post_method(this.domainMethodUrl + endpoint, data);
  }

  get_categories_pos(data:any): any {
    let endpoint = 'ecommerce_business_store.ecommerce_business_store.mobileapi.category_list'
    return this.post_method(this.domainMethodUrl + endpoint, data);
  }

  insert_address(data:any, index:any) {
    let endpoint = 'ecommerce_business_store.ecommerce_business_store.api.insert_address';
    // if (index)
      return this.post_method(this.domainMethodUrl + endpoint, data);
    // else
    //   return this.postmethod(this.baseMethod + endpoint, data);
  }


  update_address(data:any, index:any) {
    let endpoint = 'ecommerce_business_store.ecommerce_business_store.api.update_address';
    // if (index)
      return this.post_method(this.domainMethodUrl + endpoint, data);
    // else
    //   return this.postmethod(this.baseMethod + endpoint, data);
  }

  delete_address(data:any, index:any) {
    let endpoint = 'ecommerce_business_store.ecommerce_business_store.api.delete_address';
    return this.post_method(this.domainMethodUrl + endpoint, data);
  }

  admin_login(domain:any, usr:any, pwd:any) {
    let endpoint = 'ecommerce_business_store.ecommerce_business_store.mobileapi.login_customer';
    let data = {
      usr: usr,
      pwd: pwd,
      device: this.device_type,
      get_user_token: 1
    };
    return this.http.post(domain + endpoint, data, {});
  }

  get_doc_list(data:any) {
    let endpoint = "ecommerce_business_store.ecommerce_business_store.mobileapi.get_doc_list"
    return this.post_method(this.domainMethodUrl + endpoint, data);
  }


  get_order_details(data:any, index:any) {
    let endpoint = 'ecommerce_business_store.ecommerce_business_store.api.get_order_details';
    // if (index == 1) {
      return this.post_method(this.domainMethodUrl + endpoint, data);
    // } else {
    //   return this.postmethod(this.baseMethod + endpoint, data);
    // }
  }

  get_order_detail(data:any){
    let endpoint = 'ecommerce_business_store.ecommerce_business_store.v2.vendor.get_order_detail';
    return this.post_method(this.domainMethodUrl + endpoint ,data)
  }
  
  remove_combination_img(data:any){
    let endpoint = 'ecommerce_business_store.ecommerce_business_store.api.remove_combination_images';
    return this.post_method(this.domainMethodUrl + endpoint,data)
  }

  remove_combination(data:any){
    // let endpoint =  this.apiUrl_vendor + 'remove_combination'
    let endpoint =  this.apiUrl_vendor + 'remove_updateapproval_combination';
    // let endpoint = 'ecommerce_business_store.ecommerce_business_store.api.remove_combination';
    return this.post_method(this.domainMethodUrl + endpoint,data)
  }

  ping_site(domain:any) {
    if (domain[domain.length - 1] != '/')
      domain = domain + '/';
    let endpoint = 'api/method/ping';
    return this.http.post(domain + endpoint, {}, {});
  }

  get_categories(data:any): any {
    let endpoint =  this.apiUrl_vendor + 'get_categories'
    return this.get_domain(this.domainMethodUrl + endpoint);
    // let endpoint = 'ecommerce_business_store.ecommerce_business_store.api.get_Product_Categories'
    // return this.post_method(this.domainMethodUrl + endpoint, data);
  }

  get_products(data:any): any {
    let endpoint =  this.apiUrl_vendor + 'get_products'
    // let endpoint = 'ecommerce_business_store.ecommerce_business_store.api.get_all_business_products'
    return this.post_method(this.domainMethodUrl + endpoint, data);
  }
  
  get_product_details(data:any): Observable<any> {
    let endpoint =  this.apiUrl_vendor + `get_product_details?product_id=${data}`
    return this.get_domain(this.domainMethodUrl + endpoint);
  }

  get_product(data:any): any {
    let endpoint =  this.apiUrl_vendor + `get_product_details?product_id=${data}`
    return this.get_domain(this.domainMethodUrl + endpoint);
    // let endpoint = 'pos.get_product_details_data'
    // return this.post_method(this.domainMethodUrl + endpoint, {product_id:data.Product});
  }

  get_products_for_pricing(data:any): any {
    let endpoint =  this.apiUrl_vendor + 'get_products_for_pricing';
    // let endpoint =  this.apiUrl_vendor + 'get_products'
    return this.post_method(this.domainMethodUrl + endpoint, data);
  }

  update_product_prices(data:any){
    let endpoint =  this.apiUrl_vendor + 'update_product_prices'
    return this.post_method(this.domainMethodUrl + endpoint, data);
  }


  add_menu_category(data:any, type:any): any {
    var datas = {
      data: JSON.stringify(data)
    }
    let endpoint = 'ecommerce_business_store.ecommerce_business_store.mobileapi.insert_product_category'
    return $.post(this.domainMethodUrl + endpoint, datas, this.options);
  }

  // get_brands():Observable<any>{
  //   let endpoint = 'Product Brand?fields=["name","brand_name"]';
  //   return this.get_domain(this.domainResourceUrl + endpoint );
  // }

  get_discount_detail(discount_id:any):Observable<any>{
    let end_point = 'ecommerce_business_store.ecommerce_business_store.pos.get_discount_details?discount_id='+discount_id;
    return this.get_domain(this.domainMethodUrl + end_point);
  }
  

  get_specification_group():Observable<any>{
    let endpoint = 'Specification Group?fields=["name","specification_group_name"]';
    return this.get_domain(this.domainResourceUrl + endpoint );
  }

  get_specification_attributes():Observable<any>{
    let endpoint = 'Specification Attribute?fields=["name","attribute_name"]';
    return this.get_domain(this.domainResourceUrl + endpoint );
  }

  get_uom_list():Observable<any>{
    let endpoint = 'UOM';
    return this.get_domain(this.domainResourceUrl + endpoint );
  }


  get_discount_templates(){
    let endpoint = 'ecommerce_business_store.ecommerce_business_store.doctype.discount_template.discount_template.get_all_templates';
    return this.get_domain(this.domainMethodUrl + endpoint)
  }

  get_discount_template_details(data:any){
    let endpoint=`Discount%20Template/${data}`
    return this.get_domain(this.domainResourceUrl+ endpoint);
  }

  get_customer_roles(): any {
    let endpoint = 'ecommerce_business_store.ecommerce_business_store.pos.get_customer_roles'
    return this.get_domain(this.domainMethodUrl + endpoint);
  }

  get_common_settings(data: any): any {
    let endpoint = 'ecommerce_business_store.ecommerce_business_store.mobileapi.get_pos_common_settings';
    return this.post_method(this.domainMethodUrl + endpoint, data);
  }

  add_menu_item(data:any): any {
    var datas = { data: JSON.stringify(data) }
    let endpoint = 'ecommerce_business_store.ecommerce_business_store.mobileapi.insert_products'
    return $.post(this.domainMethodUrl + endpoint, datas, this.options);
  }

  get_doctype_datas(data:any): Observable<any> {
    let endpoint = data
    return this.get_domain(this.domainResourceUrl + endpoint);
  }

  insert_products(data:any): Observable<any> {
    // var datas =  JSON.stringify(data) 
    // let endpoint = 'ecommerce_business_store.ecommerce_business_store.mobileapi.insert_products'
    // let endpoint =  this.apiUrl_vendor + 'update_product_details'
    let endpoint =  this.apiUrl_vendor + 'add_update_product_details'
    return this.post_method(this.domainMethodUrl + endpoint, data);
  }

  update_products(data:any): Observable<any> { 
    let datas = { doc: data };
    let endpoint =  this.apiUrl_vendor + 'insert_product_change_approval'
    // let endpoint = 'ecommerce_business_store.ecommerce_business_store.mobileapi.insert_doc'
    return this.post_method(this.domainMethodUrl + endpoint, datas);
  }

  get_catalog_products(data:any): Observable<any> {
    // var datas = { data: JSON.stringify(data) }
    let endpoint =  this.apiUrl_vendor + 'get_catalog_products'
    // let endpoint =  this.apiUrl_vendor + 'get_products'
    return this.post_method(this.domainMethodUrl + endpoint, data);
  }

  get_centre_list(data:any): Observable<any> {
    // var datas = { data: JSON.stringify(data) }
    let endpoint =  this.apiUrl_masters + 'get_centres'
    return this.post_method(this.domainMethodUrl + endpoint, data);
  }

  get_price_mapping_list():Observable<any>{
    let endpoint = 'Product Mapping Tool?fields=["*"]';
    return this.get_domain(this.domainResourceUrl + endpoint );
  }

  add_vendor_catalog_products(data:any): Observable<any> {
    // var datas = { data: JSON.stringify(data) }
    let endpoint =  this.apiUrl_vendor + 'add_vendor_catalog_products'
    return this.post_method(this.domainMethodUrl + endpoint, data);
  }

  create_variant_combinations(data:any): Observable<any> {
    // console.log(data)
    var datas = { attributes: JSON.stringify(data) }
    let endpoint = 'ecommerce_business_store.ecommerce_business_store.doctype.product.product.create_variant_combinations'
    return this.post_method(this.domainMethodUrl + endpoint, datas);
  }

  delete_menu_item(name:any): any {
    if (localStorage['api_key'] != undefined)
      this.headers = new HttpHeaders({ 'Authorization': 'token ' + localStorage['api_key'] + ":" + localStorage['api_secret'] });
    let endpoint = 'Product/' + name;
    return this.http.delete(this.domainResourceUrl + endpoint, this.options);
  }

  uploadfiles(data:any): any {
    var datas = {  data : JSON.stringify(data) }
    let endpoint = 'ecommerce_business_store.ecommerce_business_store.mobileapi.upload_images'
    return this.post_method(this.domainMethodUrl + endpoint, datas);
    // return $.post(this.domainMethodUrl + endpoint, datas, this.options);
  }

  // uploadfiles(data): any {
  //   var datas = {  data : JSON.stringify(data) }
  //   let endpoint = 'ecommerce_business_store.ecommerce_business_store.mobileapi.upload_images'
  //   return this.postmethod(this.baseMethod + endpoint, datas);
  //   // return $.post(this.baseMethod + endpoint, datas, this.options);
  // }

    // Upload image 
    upload_image(data: any): Observable<any> {
      let endpoint = "File";
      return this.post_method(this.domainResourceUrl + endpoint, data);
    }
  
    upload_image_url(unique_name: any): Observable<any> {
      let endpoint = "File/";
      return this.get_domain(this.domainResourceUrl + endpoint + unique_name);
    }

  upload_attribute_files(data:any): any {
    var datas = {  data : JSON.stringify(data) }
    let endpoint =  this.apiUrl_vendor + 'update_combination_images'
    // let endpoint = 'ecommerce_business_store.ecommerce_business_store.api.update_combination_images'
    return this.post_method(this.domainMethodUrl + endpoint, datas);
  }

  remove_variant_options(data:any): any {
    let endpoint =  this.apiUrl_vendor + 'remove_updateapproval_options'
    // let endpoint =  this.apiUrl_vendor + 'remove_variant_options'
    return this.post_method(this.domainMethodUrl + endpoint, data);
  }

  add_update_variant_options(data:any): any {
    let endpoint =  this.apiUrl_vendor + 'add_update_variant_options'
    return this.post_method(this.domainMethodUrl + endpoint, data);
  }

  update_primary_image(data:any): any {
    let endpoint =  this.apiUrl_vendor + 'update_primary_image'
    return this.post_method(this.domainMethodUrl + endpoint, data);
  }

  upload_files(data:any): any {
    let endpoint = 'ecommerce_business_store.ecommerce_business_store.api.update_to_file';
    return $.post(this.domainMethodUrl + endpoint, data, this.options);
  }
  remove_image(data:any): any {
    var endpoint = this.apiUrl_vendor + 'delete_current_img';
    // var endpoint = 'ecommerce_business_store.ecommerce_business_store.api.delete_current_img';
    return this.post_method(this.domainMethodUrl + endpoint, data);
  }

  get_all_attributes(): any {
    var data={business: localStorage['business']}
    // let endpoint = 'ecommerce_business_store.ecommerce_business_store.mobileapi.get_all_attributes'
    // return this.post_method(this.domainMethodUrl + endpoint,data);

    let endpoint =  this.apiUrl_vendor + 'get_attributes'
    return this.get_domain(this.domainMethodUrl + endpoint);

  }

  customers_list(data:any) {
    let endpoint = 'ecommerce_business_store.ecommerce_business_store.mobileapi.get_customer_list';
    return this.post_method(this.domainMethodUrl + endpoint, data);
  }

  get_tax_templates(): any {
    // let endpoint = 'ecommerce_business_store.ecommerce_business_store.mobileapi.get_all_attributes'
    // return this.get_domain(this.domainMethodUrl + endpoint);

    let endpoint =  this.apiUrl_vendor + 'get_attributes'
    return this.get_domain(this.domainMethodUrl + endpoint);
  }

  get_vendor_dashboard(data:any) {
     let endpoint =  this.apiUrl_vendor + 'get_dashbaord_data'
    return this.get_domain(this.domainMethodUrl + endpoint);
    // let endpoint = 'ecommerce_business_store.ecommerce_business_store.mobileapi.get_vendor_dashboard';
    // // return $.post(this.domainMethodUrl + endpoint, data);
    // return this.post_method(this.domainMethodUrl + endpoint, data);
  }

  wallet_details(data:any):Observable<any>{
    let endpoint = 'ecommerce_business_store.ecommerce_business_store.api.wallet_details'
    return this.post_method(this.domainMethodUrl + endpoint,data);
  }

  get_shipping_settings(data:any) {
    let endpoint = 'ecommerce_business_store.ecommerce_business_store.mobileapi.get_settings_list';
    return this.post_method(this.domainMethodUrl + endpoint, data);
    
  }

  sub_product_category(data:any): Observable<any> {
    let endpoint = 'ecommerce_business_store.ecommerce_business_store.api.get_category_products';
    return this.post_method(this.domainMethodUrl + endpoint, data);
  }

  get_category_page_filters(data:any): Observable<any> {
    let endpoint = 'ecommerce_business_store.ecommerce_business_store.mobileapi.get_category_page_filters'
    return this.post_method(this.domainMethodUrl + endpoint, data);
  }

  get_cart_items(data:any): Observable<any> {
    let endpoint = 'ecommerce_business_store.ecommerce_business_store.api.get_cartItems';
    return this.post_method(this.domainMethodUrl + endpoint, data);
  }

  delete_cart_items(data:any): Observable<any> {
    let endpoint = 'ecommerce_business_store.ecommerce_business_store.api.deleteCartItems';
    return this.post_method(this.domainMethodUrl + endpoint, data);
  }

  update_cart_items(data:any): Observable<any> {
    let endpoint = 'ecommerce_business_store.ecommerce_business_store.api.update_cartitem';
    return this.post_method(this.domainMethodUrl + endpoint, data);
  }

  insert_cart_items(data:any): Observable<any> {
    let endpoint = 'ecommerce_business_store.ecommerce_business_store.api.insert_cartItems';
    return this.post_method(this.domainMethodUrl + endpoint, data);
  }

  check_cartitems_stock_mob(data:any): Observable<any> {
    let endpoint = 'ecommerce_business_store.ecommerce_business_store.api.check_cartitems_stock_mob';
    return this.post_method(this.domainMethodUrl + endpoint, data);
  }

  retrieve_data(data:any) {
    let endpoint = 'ecommerce_business_store.ecommerce_business_store.api.get_all_PosCart'
    return this.post_method(this.domainMethodUrl + endpoint, data);
  }

  // remove_all_pos_cart(user_id)
  remove_all_pos_cart(data:any) {
    let endpoint = 'ecommerce_business_store.ecommerce_business_store.api.remove_all_pos_cart'
    return this.post_method(this.domainMethodUrl + endpoint, data);
  }

  // remove_pos_cart(cart_id)
  remove_pos_cart(data:any) {
    let endpoint = 'ecommerce_business_store.ecommerce_business_store.api.remove_pos_cart'
    return this.post_method(this.domainMethodUrl + endpoint, data);
  }

  hold_order(data:any): any {
    let endpoint = 'ecommerce_business_store.ecommerce_business_store.api.posHoldOrder';
    return this.post_method(this.domainMethodUrl + endpoint, data);
  }

  table_order_update(data:any): any {
    let endpoint = 'ecommerce_business_store.ecommerce_business_store.mobileapi.update_table_order'
    return this.post_method(this.domainMethodUrl + endpoint, data);
  }

  Insert_dineInorder(data:any): any {
    let endpoint = 'ecommerce_business_store.ecommerce_business_store.api.mobile_insert_order';
    // let endpoint = 'ecommerce_business_store.ecommerce_business_store.mobileapi.mobile_waiter_insert_order'
    return this.post_method(this.domainMethodUrl + endpoint, data);
  }

  update_order(data:any): any{
    let endpoint = 'ecommerce_business_store.ecommerce_business_store.pos.update_order';
    return this.post_method(this.domainMethodUrl + endpoint, data);
  }

  get_sku_product_info(data:any): any{
    let endpoint = 'ecommerce_business_store.ecommerce_business_store.api.get_sku_product_info';
    return this.post_method(this.domainMethodUrl + endpoint, data);
  }


  update_in_process_status(data:any) {
    let endpoint = 'ecommerce_business_store.ecommerce_business_store.doctype.vendor_orders.vendor_orders.update_in_process_status';
    return this.post_method(this.domainMethodUrl + endpoint, data);
  }

  Update_doc(data:any):any {
    var doc={
      doc:JSON.stringify(data)
    }
    let endpoint = 'ecommerce_business_store.ecommerce_business_store.mobileapi.update_doc';
    return this.post_method(this.domainMethodUrl + endpoint, doc);
  }

  calculate_product_discount(data:any) {
    let endpoint = 'ecommerce_business_store.ecommerce_business_store.mobileapi.calculate_ngcart_discounts';
    return this.post_method(this.domainMethodUrl + endpoint, data);
  }

  get_discount_coupon_list(data:any){
    let endpoint = 'ecommerce_business_store.ecommerce_business_store.pos.get_discount_coupon_list';
    return this.post_method(this.domainMethodUrl + endpoint, data);
  }

  get_order_discount(data:any) {
    let endpoint = 'ecommerce_business_store.ecommerce_business_store.api.get_order_discount';
    return this.post_method(this.domainMethodUrl + endpoint, data);
  }

  get_discount_list(data:any){
   let endpoint = 'ecommerce_business_store.ecommerce_business_store.pos.get_discount_list';
   return this.post_method(this.domainMethodUrl + endpoint, data); 
  }

  insert_discounts(data:any){
   let endpoint = 'ecommerce_business_store.ecommerce_business_store.mobileapi.insert_discounts';
   return this.post_method(this.domainMethodUrl + endpoint, data); 
  }

  get_pos_left_menu_with_count(data:any){
   let endpoint = 'ecommerce_business_store.ecommerce_business_store.pos.get_pos_left_menu_with_count';
   return this.post_method(this.domainMethodUrl + endpoint, data); 
  }

  sasslogin(data:any) {
    let endpoint = 'ecommerce_business_store.ecommerce_business_store.mobileapi.login_customer';
    return $.post(this.domainMethodUrl + endpoint, data, this.options);
  }

  get_all_products() {
    // let endpoint = 'ecommerce_business_store.ecommerce_business_store.pos.get_all_products';
    // let endpoint = this.apiUrl_vendor + 'get_categories';
    // return this.post_method(this.domainMethodUrl + endpoint, {business:localStorage['business']});

      let endpoint =  this.apiUrl_vendor + 'get_categories'
      return this.get_domain(this.domainMethodUrl + endpoint);

  }

  get_payment_method(data:any): Observable<any> {
    let endpoint ='ecommerce_business_store.ecommerce_business_store.mobileapi.get_payment_methods_list';
    // let endpoint = 'ecommerce_business_store.ecommerce_business_store.api.get_payment_method';
    return this.post_method(this.domainMethodUrl + endpoint, data)
  }

  get_shipping_method(data:any) {
    let endpoint = 'ecommerce_business_store.ecommerce_business_store.api.get_shipping_method';
    return $.post(this.domainMethodUrl + endpoint, data, this.options);
  }

  get_orders_lists(data:any): any {
    let endpoint = 'ecommerce_business_store.ecommerce_business_store.mobileapi.get_orders_list';
    return this.post_method(this.domainMethodUrl + endpoint, data);
  }

  get_last_closing_balance(data: any): any {
    let endpoint = 'ecommerce_business_store.ecommerce_business_store.mobileapi.get_last_closing_balance';
    return this.post_method(this.domainMethodUrl + endpoint, data);
  }

  insert_opening_balance(data: any): any {
    let endpoint = 'ecommerce_business_store.ecommerce_business_store.mobileapi.insert_opening_balance';
    return this.post_method(this.domainMethodUrl + endpoint, data);
  }

  update_closing_balance(data: any): any {
    let endpoint = 'ecommerce_business_store.ecommerce_business_store.mobileapi.update_closing_balance';
    return this.post_method(this.domainMethodUrl + endpoint, data);
  }

  get_user_opening_balance(data: any): any {
    let endpoint = 'ecommerce_business_store.ecommerce_business_store.mobileapi.get_user_cash_register';
    return this.post_method(this.domainMethodUrl + endpoint, data);
  }

  get_mode_of_payments(data: any): any {
    let endpoint = 'ecommerce_business_store.ecommerce_business_store.mobileapi.pos_mode_of_payments';
    return this.post_method(this.domainMethodUrl + endpoint, data);
  }

  insert_multiple_payments(data: any): any {
    let endpoint = 'ecommerce_business_store.ecommerce_business_store.mobileapi.insert_order_payments';
    return this.post_method(this.domainMethodUrl + endpoint, data);
  }

  search_customers(data: any): any {
    let endpoint = 'ecommerce_business_store.ecommerce_business_store.mobileapi.search_customers';
    return this.post_method(this.domainMethodUrl + endpoint, data);
  }

  validate_attributes_stock(data:any): Observable<any> {
    let endpoint = 'ecommerce_business_store.ecommerce_business_store.api.validate_attributes_stock';
    return this.post_method(this.domainMethodUrl + endpoint, data);
  }

  customer_login(data:any) {
    let endpoint = this.apiUrl_vendor + 'login';
    return this.post_method(this.domainMethodUrl + endpoint, data);
  }

  coupon_code(data:any): any {
    let endpoint = 'ecommerce_business_store.ecommerce_business_store.api.validate_coupon'
    return this.post_method(this.domainMethodUrl + endpoint, data);
  }

  order_list(data:any): any {
    let endpoint = 'ecommerce_business_store.ecommerce_business_store.api.order_list';
    return this.post_method(this.domainMethodUrl + endpoint, data);
  }

  domain_customer_Info(email:any): any {
    var data = {
      user: email
    }
    let endpoint = 'ecommerce_business_store.ecommerce_business_store.api.get_customer_info?user=' + email;
    return this.get_domain(this.domainMethodUrl + endpoint);
  }

  get_order_search_list(data:any): any {
    let endpoint = 'ecommerce_business_store.ecommerce_business_store.mobileapi.get_order_search_list'
    return this.post_method(this.domainMethodUrl + endpoint, data);
  }

   // 
  sales_report(data:any):Observable<any>{
    // let endpoint = 'ecommerce_business_store.ecommerce_business_store.reports.sales_reports';
    let endpoint = this.apiUrl_vendor + 'sales_report';
    return this.post_method(this.domainMethodUrl + endpoint, data);
  }

  customer_report(data:any):Observable<any>{
    // let endpoint = 'ecommerce_business_store.ecommerce_business_store.reports.customer_report';
    let endpoint = this.apiUrl_vendor + 'customer_report';
    return this.post_method(this.domainMethodUrl + endpoint, data);
  }

  best_selling_items_amount_reports(data:any):Observable<any>{
    // let endpoint = 'ecommerce_business_store.ecommerce_business_store.reports.best_selling_items_amount_reports';
    let endpoint = this.apiUrl_vendor + 'best_selling_items_amount_report';
    return this.post_method(this.domainMethodUrl + endpoint, data);
  }

  daily_sales_reports(data:any):Observable<any>{
    // let endpoint = 'ecommerce_business_store.ecommerce_business_store.reports.daily_sales_reports?business='+data.business+'&date='+data.date;
    let endpoint = this.apiUrl_vendor + 'daily_sales_report';
    return this.post_method(this.domainMethodUrl + endpoint, data);
     // return this.post_method(this.domainMethodUrl + endpoint, data);
  }

  monthly_sales_reports(data:any):Observable<any>{
    // let endpoint = 'ecommerce_business_store.ecommerce_business_store.reports.monthly_sales_report';
    let endpoint = this.apiUrl_vendor + 'monthly_sales_report';
    return this.post_method(this.domainMethodUrl + endpoint, data);
  }

  yearly_sales_reports(data:any):Observable<any>{
    // let endpoint = 'ecommerce_business_store.ecommerce_business_store.reports.yearly_sales_reports';
    let endpoint = this.apiUrl_vendor + 'yearly_sales_report'
    return this.post_method(this.domainMethodUrl + endpoint, data);
  }

  best_selling_items_quantity_reports(data:any):Observable<any>{
    // let endpoint = 'ecommerce_business_store.ecommerce_business_store.reports.best_selling_items_quantity_reports';
    let endpoint = this.apiUrl_vendor + 'best_selling_items_quantity_report'
    return this.post_method(this.domainMethodUrl + endpoint, data);
  }

  product_reports(data:any){
    let endpoint = this.apiUrl_vendor + 'product_report';
    return this.post_method(this.domainMethodUrl + endpoint , data);
  }

  commission_reports(data:any){
    let endpoint = this.apiUrl_vendor + 'commission_report';
    return this.post_method(this.domainMethodUrl + endpoint , data);
  }

  item_sales_reports(data:any){
    let endpoint = this.apiUrl_vendor + 'item_sales_report';
    return this.post_method(this.domainMethodUrl + endpoint , data);
  }



  get_years_list() {
    let endpoint = 'ecommerce_business_store.ecommerce_business_store.reports.get_years';
    return this.post_method(this.domainMethodUrl + endpoint, {});
  }

  get_all_category(data:any,limit_page_length:any,limit_start:any):Observable<any>{
    let endpoint = 'ecommerce_business_store.ecommerce_business_store.api.get_parent_categories';
    return this.post_method(this.domainMethodUrl + endpoint, data)
    // let endpoint = 'Product Category?fields=["name","category_name","display_order","is_active","menu_image","mobile_image","category_image","name"]&limit_page_length='+limit_page_length+'&limit_start='+limit_start;
    // return this.get_domain(this.domainResourceUrl + endpoint)
  }
  cancel_order(data:any){
    let endpoint = 'ecommerce_business_store.ecommerce_business_store.mobileapi.cancel_order';
    return this.post_method(this.domainMethodUrl + endpoint, data);
  }
  return_request_status(data:any){
    let endpoint = 'ecommerce_business_store.ecommerce_business_store.api.return_request_status';
    return this.post_method(this.domainMethodUrl + endpoint, data);
  }

  get_return_request_info(data:any):Observable<any>{
    let endpoint = 'ecommerce_business_store.ecommerce_business_store.api.get_return_request_info';
    return this.post_method(this.domainMethodUrl + endpoint,data);
  }

  get_return_request_details():Observable<any>{
    let endpoint = 'ecommerce_business_store.ecommerce_business_store.mobileapi.get_return_request_details';
    return this.get_domain(this.domainMethodUrl + endpoint);
  }

  check_distance_by_latlng(data:any):Observable<any> {
    let endpoint = 'ecommerce_business_store.ecommerce_business_store.api.check_distance_by_latlng';
    return this.post_method(this.domainMethodUrl + endpoint, data);
  }

  pincode_availability(data:any):Observable<any> {
    let endpoint = 'ecommerce_business_store.ecommerce_business_store.api.check_pincode_availability';
    return this.post_method(this.domainMethodUrl + endpoint, data);
  }
  
  create_return_request(data:any):Observable<any>{
    let datas = { data:  JSON.stringify(data)}
    let endpoint = 'ecommerce_business_store.ecommerce_business_store.api.create_return_request';
    return this.post_method(this.domainMethodUrl + endpoint,datas);
  }

  get_dacType_names(data:any){
    let endpoint = 'Doctype';
    return this.http.get(this.domainResourceUrl + endpoint);
  }

  
  customer_Info(info):Observable<any> {
    let guest =  (localStorage['guestRefId'] && localStorage['guestRefId'] != '' ) ? localStorage['guestRefId'] : null
    info.guest_id = guest;
    let endpoint = this.apiUrl_customer +  'get_customer_info';
    return this.post_method(this.domainMethodUrl + endpoint, info);
  }


  tabs_items =[ 
        {
        title:'Home',
        route: '/admin-dashboard',
        icon : '/assets/footer/home.svg',
        tab: 'home',
        enable: 1,
    },
    {
      title:'Orders',
      route: '/orders',
      icon : '/assets/footer/mycart.svg',
      tab: 'orders',
      enable: 1
    },
    {
      title:'Product',
      route: '/product-list',
      icon : '/assets/footer/category.svg',
      tab: 'wishlist',
      enable: 1
    },
    {
      title:'Account',
      route: '/my-accounts',
      icon : '/assets/footer/user-sidemenu.svg',
      tab: 'my-profile',
      enable: 1
    },
  ]

  filter = '';
  get_link_field_options_child(refdoc): Observable<any> {

    if(refdoc =="Classified Category"){
      this.filter= `?limit_page_length=100&fields=["category_name","name","parent_category"]&order_by=name%20asc`
    }else if(refdoc =="Job Category"){
      this.filter= `?limit_page_length=100&fields=["category_name","name","parent_category"]&order_by=category_name%20asc`
    }else if(refdoc == 'Job Role'){
      this.filter= `?fields=["*"]`
    }else if(refdoc == 'Expected Salary Type'){
      // let parent_salary_type = '/' + this.salary_type;
      // this.filter = parent_salary_type;
    }
    
    let endpoint = this.ref_doc_type + this.filter;
    return this.get_domain(this.domainResourceUrl + endpoint);
  }

  // Get
  page_length = "?limit_page_length=100&order_by=name%20asc"
  get_link_field_options(): Observable<any> {
    if(this.ref_doc_type == 'Recruiter Company Size'){
      this.page_length = "?limit_page_length=100&order_by=creation%20desc"
    }else if(this.ref_doc_type == 'Country'){
      this.page_length = '?filters=[["enabled","=",1]]&limit_page_length=10000&order_by=name%20asc'
    }else if(this.ref_doc_type == 'State'){
      this.page_length = '?limit_page_length=10000&order_by=name%20asc'
    }
    let endpoint = this.ref_doc_type + this.page_length;
    return this.get_domain(this.domainResourceUrl + endpoint);
  }

  c_city_state:any = ''
  get_link_field_city_options(data): Observable<any> {
    let endpoint = this.c_city_state;
    return this.get_domain(this.domainResourceUrl + endpoint);
  }


  get_doc_data(doctype): Observable<any> {
    let datas = { 'doctype' : doctype }
    let endpoint = this.apiUrl_common + "get_doc_meta"
    return this.post_method(this.domainMethodUrl + endpoint, datas);
    // return this.get(this.baseMethod + endpoint + doc_name);
  }     
        
  get_link_field_options_parent(refdoc): Observable<any> {
    console.log(refdoc);
    if(refdoc =="Classified Category"){
        this.filter= '?limit_page_length=100&filters=[["is_group","=","1"]]&fields=["category_name","name"]&order_by=name%20asc'
     }
     else if(refdoc =='Job Category'){
       this.filter= '?limit_page_length=100&filters=[["is_group","=","1"]]&fields=["category_name","name"]&order_by=category_name%20asc'
     } else if(refdoc == 'Job Role'){
      // this.filter= `?fields=["*"]`
      this.filter = '?limit_page_length=100&order_by=name%20asc&filters=[["is_group","=",1]]'
    }else if(refdoc == 'Expected Salary Type'){
      this.filter= ''
    }
  
      let endpoint = this.ref_doc_type + this.filter;
      return this.get_domain(this.domainResourceUrl + endpoint);

  }

  web_form_dynamic(data): Observable<any> {
    let endpoint = "Web Form/" + data;
    return this.get_domain(this.domainResourceUrl + endpoint);

  }

  insert_update_customer(data):Observable<any> {
    let endpoint = this.apiUrl_customer + 'insert_update_customer';
    return this.post_method(this.domainMethodUrl + endpoint, data);
  }

  update_password(data):Observable<any>{
    let endpoint = 'ecommerce_business_store.ecommerce_business_store.api.update_password'
    return this.post_method(this.domainMethodUrl + endpoint,data);
  }

  
  get_profile_details():Observable<any> {
    let endpoint = this.apiUrl_vendor +  'get_profile';
    return this.get_domain(this.domainMethodUrl + endpoint);
  }

  profile_values:any;
  get_profiles(){
    this.get_profile_details().subscribe((res:any)=>{
       if(res && res['message'] && res['message']['status'] && res['message']['status'] == "Success"){
        this.profile_values = res['message']['data'];
       }
    })
  }

  
  async filSizeAlert() {
    const alert = await this.alertCtrl.create({
      cssClass: 'my-custom-alert-class',
      header: "File Size Exceeded.!",
      message: 'Please Upload Files Below Size Of 10.0 MB...!',
      buttons: [{
        text: 'OK',
        handler: () => {
          this.alertCtrl.dismiss();
        }
      }]
    });
    await alert.present();
  }

  close_modal() {
    this.modalCtrl.dismiss();
  }

  tab_buttons(sub_header_data,route,type){

    if(sub_header_data.length != 0){
      sub_header_data.map((r,i)=>{
        if(r[type] == route){
          r['isActive'] = true;
          this.tab_center.next(i + 1);
        }else{
          r['isActive'] = false;
        }

      })
   }

  }

  onSearch($event){
    // this function must to declare
  }

  CustomSearch(term: string, item){
    // this function call used to custome search box (ll place search box inside the derop down)
    // console.log("Item Type is ---->",typeof(item))
    // console.log(item);
    var String_list : any = typeof(item) === 'number' ? item.toString() : null;
    var String_list : any = typeof(item) === 'string' ? item : null;
    if(typeof(item)=='object'){
      var keys=Object.keys(item);
      if(keys?.length==1){
        const [first] = keys;
        String_list=item[first];
      }else if(keys?.length>1){
         keys.map(res=>{ 
          if(res == 'options' || res == 'language_name' || res == 'value' || res == 'category_name'){
              String_list=item[res];
          }
        })
      }
    }
    term = term.toLocaleLowerCase(); 
    //  console.log(term,String_list.toLocaleLowerCase());
    return String_list.toLocaleLowerCase().indexOf(term) > -1;
  }

  preview_image(url){
    window.open(url,'_blank');
  }

  
  check_device_type() {
    if (this.platform.is('android')) {
      return 'Android Mobile App'
    }
    else if (this.platform.is('ios')) {
      return 'IOS Mobile App'
    }
    else {
      return 'Website'
    }
  }

  getPlaceAutocomplete(input,type) {
    const autocomplete = new google.maps.places.Autocomplete(input,
        {
          componentRestrictions: { country: 'IN' },
          types: ['establishment']  // 'establishment' / 'address' / 'geocode'
        });
        google.maps.event.addListener(autocomplete, 'place_changed', (res) => {
          // console.log(res);
            const place = autocomplete.getPlace();
            // console.log(place);
            this.validate_location(place,type)
        });
   }

   validate_location(data,type){

      this.location_info.latitude = data.geometry.location.lat();
      this.location_info.longitude = data.geometry.location.lng();
      this.located.next('located');
      
      const geocoder =  new google.maps.Geocoder();
      geocoder.geocode({ placeId: data.place_id }, (data,status) => {
        if (status == google.maps.GeocoderStatus.OK) {
            data[0].address_components.map(res =>{
              // console.log(data[0])
                if(res.types[0] == "postal_code"){
                  this.location_info.zipcode = res.long_name;
                  // this.zipcode_availbility(this.location_info.zipcode,data);   
                }
                res.types[0] == "country" ? this.location_info.country = res.long_name : null
                res.types[0] == "administrative_area_level_1" ? this.location_info.state = res.long_name : null
                res.types[0] == "locality" ?   (this.city,this.location_info.city = res.long_name) : null
                this.location = data[0].formatted_address; 
                this.location_info.address = data[0].formatted_address.split(this.location_info.city)[0].trim();
                if(type == 'get_map_fields'){
                  this.map_fields_get.next('get_values')
                } 
            })
        }
      })
  }

  decode(latlng,type) {
    const geocoder =  new google.maps.Geocoder();
    // const infowindow = new google.maps.InfoWindow();
   geocoder.geocode({ location: latlng }, (data,status) => {
    if (status == google.maps.GeocoderStatus.OK) {
      data[0].address_components.map(res =>{
        this.location_info.latitude = data[0].geometry.location.lat();
        this.location_info.longitude = data[0].geometry.location.lng();
        // console.log(this.location_info)
          if(res.types[0] == "postal_code"){
            this.location_info.zipcode = res.long_name;
            // this.zipcode_availbility(this.location_info.zipcode,data);   
          }
          res.types[0] == "country" ? this.location_info.country = res.long_name : null
          res.types[0] == "administrative_area_level_1" ? this.location_info.state = res.long_name : null
          res.types[0] == "locality" ?   (this.city,this.location_info.city = res.long_name) : null
          this.location = data[0].formatted_address; 
          this.location_info.address = data[0].formatted_address.split(this.location_info.city)[0].trim();
          if(type == 'get_map_fields'){
            this.map_fields_get.next('get_values')
          } 
          // console.log(this.location_info)
      })
    }
    })
  }

  skeleton = true;
  cat_products:any = [];
  product_page_no = 1;
  inventory_category = '';
  inventory_search_txt = '';
  no_inventory_products = false;
  
  get_inventory_products(){
    let data = {
      category: this.inventory_category == 'All' ? '' : this.inventory_category, 
      search_txt:this.inventory_search_txt,
      page_no:this.product_page_no,
      page_size:10
    }
    // this.DBservice.get_products_for_pricing(data);

    this.get_catalog_products(data).subscribe(res=>{

      if(res.message && res.message.length != 0){


        if(this.product_page_no == 1){
          this.cat_products = res.message;
          this.skeleton = false;
        }else{
          this.cat_products = [...this.cat_products,...res.message];
          this.skeleton = false;
        }

        this.check_added_values(this.cat_products);

      }else if(res.message && res.message.length == 0){
        this.no_inventory_products = true;
        this.product_page_no == 1 ?  this.cat_products = [] : null;
        this.skeleton = false;
      }
    })
  }

  check_added_values(data){

    if(this.inventory_items.length != 0){
      data.map(res=>{
        let get_value = this.inventory_items.find(r=> r['name'] == res.name);
        if(get_value){

          let count1 = this.inventory_items.filter(r=>{ return r.name == res.name})
          if((count1.length == res.variants.length) || (res.variants.length == 0)){
           res['Added_to_inventory'] = 1;
          }else{
           res['Added_to_inventory'] = 0;
          }
        }else{
          res['Added_to_inventory'] = 0;
        }
       
       })
     }else{
      data.map(res=>{
        res['Added_to_inventory'] = 0;
      })
     }
  }

  async clear_cart(){
    let alert = await this.alertCtrl.create({
      header: 'Confirm',
      message: 'Are you sure do you want to clear your inventory items?',
      buttons: [
        {
          text: 'No',
          role: 'cancel'
        },
        {
          text: 'Yes',
          handler: () => {
            this.inventory_items = [];
            this.storage.remove('inventroy_items');
            this.check_added_values(this.cat_products);
            this.ismobile ? this.modalCtrl.dismiss() : null;
          }
        }
      ]
    })
    await alert.present();

  }

  remove_item(array,index,type){
    array.splice(index,1);
     if(type == 'store'){
      this.storage.set('inventroy_items', this.inventory_items);
      this.check_added_values(this.cat_products);
     }
  }

  get_inventroy_items() {
    this.storage.get('inventroy_items').then((val) => {
        if (val == null || val == undefined) {
            this.inventory_items = []
            return this.inventory_items;
        }
        else {
            return this.inventory_items = val
        }

    });
 }


 skeleton_pricing = true;
 product_list:any = [];
 price_page_no = 1;
 price__category = '';
 price__search_txt = '';
 no_price__products = false;
 centre = ''
 get_products_list(){
   let data = {
     category: this.price__category == 'All' ? '' : this.price__category, 
     search_txt:this.price__search_txt,
     page_no:this.price_page_no,
     page_size:10,
     centre:this.centre
   }
   // this.DBservice.get_products_for_pricing(data);

   this.get_products_for_pricing(data).subscribe(res=>{

     if(res.message && res.message.length != 0){


       if(this.price_page_no == 1){
         this.product_list = res.message;
         this.skeleton_pricing = false;
       }else{
         this.product_list = [...this.product_list,...res.message];
         this.skeleton_pricing = false;
       }


     }else if(res.message && res.message.length == 0){
       this.no_price__products = true;
       this.price_page_no == 1 ?  this.product_list = [] : null;
       this.skeleton_pricing = false;
     }
   })
 }

 //Support
 get_detail(doc:any){
  let endpoint = doc.doctype +'/'+ doc.id;
  return this.get_domain(this.domainResourceUrl + endpoint)
 }

 save_detail(data:any){
  let endpoint = data.doctype;
  return this.post_method(this.domainResourceUrl + endpoint , data)
 }

 post_issue(data:any){
  let endpoint = 'ecommerce_business_store.ecommerce_business_store.v2.vendor.create_issue';
  return this.post_method(this.domainMethodUrl + endpoint ,data);
 }

 get_all_issue(data:any){
  let endpoint = `ecommerce_business_store.ecommerce_business_store.v2.vendor.get_issue_list?page_no=${data.start}&page_length=${data.length}`;
  return this.get_domain(this.domainMethodUrl + endpoint);
 }

 get_issue_detail(data:any){
  let endpoint = 'ecommerce_business_store.ecommerce_business_store.v2.vendor.get_issue_details?issue_id='+ data.issue_id;
  return this.get_domain(this.domainMethodUrl + endpoint);
 }

 forget_password(data):Observable<any>{
  // let endpoint = 'frappe.core.doctype.user.user.reset_password';
  let endpoint = 'ecommerce_business_store.ecommerce_business_store.api.send_user_forget_pwd_mail';
  return this.post_method(this.domainMethodUrl + endpoint , data);
}

get_page_details(data): Observable<any> {
  let endpoint = 'ecommerce_business_store.ecommerce_business_store.mobileapi.get_page_details';
  return this.post_method(this.domainMethodUrl + endpoint, data);
}

   
 async logout() {
   console.log('logout')
  let alert = await this.alertCtrl.create({
    header: 'Confirm',
    message: 'Do you really want to logout ?',
    buttons: [
      {
        text: 'No',
        role: 'cancel'
      },
      {
        text: 'Yes',
        handler: () => {
          // this.router.navigateByUrl('/login');
          localStorage.clear();
          this.storage.remove('category_list');
          this.storage.remove('customer_list');
          this.storage.remove('inventroy_items');
          this.storage.remove('selectmenu');
          this.storage.clear();
          this.router.navigateByUrl('/login');
          this.menu.enable(false, 'profileMenu');
          // this.router.navigateByUrl('/');
          // location.href = '/';
        }
      }
    ]
  })
  await alert.present();
}

  getRandomColor(data) {

    if(data && data.length != 0){
      data.map(r=>{
       var color = Math.floor(Math.random()*16777215).toString(16);
       color = '#' + ('000000' + color).slice(-6);
       r.color = color;
      // r.bg_color = color;  
       r.bg_color = this.hexToRgb(r.color,0.1);
      })
    }
  
    // console.log(typeof(data));
  }

  
  getRandomColor_obj(data) {
       var color = Math.floor(Math.random()*16777215).toString(16);
       color = '#' + ('000000' + color).slice(-6);
       data.color = color;
       data.bg_color = this.hexToRgb(data.color,0.1);
  }
 

  hexToRgb(hex, alpha) {
    hex   = hex.replace('#', '');
    var r = parseInt(hex.length == 3 ? hex.slice(0, 1).repeat(2) : hex.slice(0, 2), 16);
    var g = parseInt(hex.length == 3 ? hex.slice(1, 2).repeat(2) : hex.slice(2, 4), 16);
    var b = parseInt(hex.length == 3 ? hex.slice(2, 3).repeat(2) : hex.slice(4, 6), 16);
    if ( alpha ) {
       return 'rgba(' + r + ', ' + g + ', ' + b + ', ' + alpha + ')';
    }
    else {
       return 'rgb(' + r + ', ' + g + ', ' + b + ')';
    }
  }

  prev_scroll;
  scrolled(data) {
    // console.log("DATA",data);
    // data.detail.scrollTop < data.detail.startY

    // if (data.detail.scrollTop > this.prev_scroll){
    //     this.header = false;
    // } else {
    //     this.header = true;
    // }

    this.prev_scroll = data.detail.scrollTop
    // if (data.detail.scrollTop < 80 && this.content_video) {
    //   // console.log(data.detail,"--DATA")
    //   this.video_header = true;
    // } else {
    //   this.video_header = false;
    // }

    if (data.detail.scrollTop < 150) {
      // console.log(data.detail)
      this.scroll_event.desktop_header = true;
    } else {
      this.scroll_event.desktop_header = false
    }

    if (data.detail.scrollTop < 200) {
      this.scroll_event.mobile_header = false;
    } else {
      this.scroll_event.mobile_header = true;
    }


    if (data.detail.scrollTop < 61) {
      this.scroll_event.no_search_icon = false;
    } else {
      this.scroll_event.no_search_icon = true;
    }

  }

}


